import { Injectable } from '@angular/core';
import { IDataModuleColumn } from './interface/iDataModuleColumnService';

@Injectable()
export class DataModuleColumnService {
  getIcon(type: IDataModuleColumn) {
    return type.getDataColumnIcon();
  }
}
